import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const trackEvent = async (eventType, payload = {}) => {
  try {
    await axios.post(`${API}/analytics/events`, {
      event_type: eventType,
      page: window.location.pathname,
      ...payload,
    });
  } catch (error) {
    // Analytics should never interrupt a customer action.
  }
};
